export const getChangedValues = (
  formData,
  initialFormData,
  thirdTrainOption,
  time,
  selectTrainType,
  selectedInspModel,
  selectedTrainModel,
  selectDatasetType,
  selectedDataset
) => {
  const changedValues = initialFormData ? {} : { ...formData };
  const inputData = { ...formData };

  if (initialFormData) {
    Object.keys(inputData).forEach((key) => {
      if (inputData[key] !== initialFormData[key]) {
        changedValues[key] = inputData[key];
      }
    });
    if (thirdTrainOption) {
      const timeFields = ["period", "week", "weekday", "exe"];
      timeFields.forEach((field) => {
        if (time[field] !== initialFormData.time?.[field]) {
          if (!changedValues.time) {
            changedValues.time = {};
          }
          changedValues.time[field] = time[field];
        }
      });
    }
  } else {
    if (thirdTrainOption) {
      changedValues.time = { ...time };
    }
  }

  if (selectTrainType === "continue") {
    if (selectedInspModel) {
      changedValues.inspModel_id = selectedInspModel.id;
    }
  } else {
    if (selectedTrainModel) {
      changedValues.trainModel_id = selectedTrainModel.id;
    }
  }

  if (selectDatasetType === "db") {
    // DB 타입일 때
    if (selectedDataset?.uuid) {
      changedValues.dataSet_uuid = selectedDataset.uuid;
    }
    // image_period와 material_name 제거
    delete changedValues.image_period;
    delete changedValues.material_name;
  } else {
    // Condition 타입일 때
    changedValues.image_period = formData.image_period;
    changedValues.material_name = formData.material_name;
    // dataSet_uuid 제거
    delete changedValues.dataSet_uuid;
  }
  // selectedDataset 객체 제거 (API에 불필요)
  delete changedValues.dataSet;
  return changedValues;
};
